<template>
  <section class="b b-grey-50 px-4 py-6 " data-test-id="review-snapshot-fit-rating">
    <h3 class="mb-4 title-5 ">
      {{ $t.fitRating }}
    </h3>
    <div class="space-y-4">
      <div v-for="(type, i) in fitRatings" :key="i" >
        <p :id="`fit-rating-${i}`" >
          {{ type.name }}
        </p>
        <vf-meter
          v-if="type.display_values?.length"
          :aria-labelledby="`fit-rating-${i}`"
          :aria-valuetext="getFitRatingValues(type).label"
          data-test-id="review-snapshot-fit-rating-scale"
          :max-label="type.display_values[type.display_values.length - 1]"
          :max-value="type.display_values.length"
          :min-label="type.display_values[0]"
          :value="getFitRatingValues(type).value"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { ProductReviewsRollupProperty } from '#root/api/clients/product/data-contracts'

defineProps<{
  fitRatings: ProductReviewsRollupProperty[]
}>()
</script>
